export const BREAKPOINT_TO_COLUMN_COUNT = {
  phones: 2,
  tablets: 3,
  desktops: 4,
  wide: 5,
} as const
export const HOME_PREFIX = 'Home'
